import React from 'react';
import { Typography, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import Footer from '../Components/Footer';
const { Title } = Typography;

const RefundScreen = () => {
  const gradientTextStyle = {
    backgroundImage: 'linear-gradient(-45deg, #7c3aed, #a855f7, #d946ef)',
    backgroundSize: '200% 200%',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    animation: 'gradient 5s ease infinite',
    fontWeight: '900',
  };

  return (
    <div className="min-h-screen relative overflow-hidden bg-gray-50">
      {/* Back Button */}
      <div className="absolute top-4 left-4 z-10">
        <Link to="/">
          <Button 
            type="text"
            icon={<ArrowLeftOutlined />}
            className="flex items-center text-purple-700 hover:text-purple-900 font-semibold text-lg hover:bg-purple-50 rounded-full px-6 py-2 h-auto"
          >
            Back to Home
          </Button>
        </Link>
      </div>

      {/* Background Gradients */}
      <div className="absolute inset-0 bg-[conic-gradient(at_top_right,_var(--tw-gradient-stops))] from-indigo-200/80 via-purple-100/80 to-pink-100/80 -z-10" />
      <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-gradient-to-bl from-purple-300/30 to-blue-300/30 rounded-full blur-3xl -z-10 animate-pulse" />
      <div className="absolute bottom-0 left-0 w-2/3 h-2/3 bg-gradient-to-tr from-pink-200/30 to-indigo-300/30 rounded-full blur-3xl -z-10 animate-pulse" />

      <div className="container mx-auto px-4 py-12 pt-20">
        <div className="max-w-4xl mx-auto">
          {/* Header Section */}
          <div className="text-center mb-16">
            <div className="inline-block mb-4 px-6 py-2 rounded-full bg-gradient-to-r from-purple-100 to-pink-100 text-purple-700 text-sm font-semibold shadow-lg">
              💰 Return & Refund Policy
            </div>
            <h1 className="text-6xl font-black mb-6" style={gradientTextStyle}>
              Our Refund Policy
            </h1>
            <p className="text-xl text-gray-600">
              Last updated on <strong className="text-purple-700">13/02/2025</strong>
            </p>
          </div>

          {/* Main Content */}
          <div className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-xl border border-white/50 p-8 md:p-12 space-y-8">
            <div className="prose prose-lg max-w-none">
              <p className="text-lg text-gray-700">
                Thank you for shopping at <strong className="text-purple-700">CarouselPost.in</strong>.
              </p>
              <p className="text-gray-700">
                The following terms are applicable for any products that you have purchased from us.
              </p>

              <div className="mt-12">
                <h2 className="text-4xl font-black mb-6" style={gradientTextStyle}>Eligibility for Refunds</h2>
                <p className="text-gray-700">We offer refunds under the following circumstances:</p>
                <ul className="space-y-3 mt-4">
                  {[
                    "If the service is not delivered as promised due to an error on our end.",
                    "If a technical issue caused by our platform prevents you from accessing the features you paid for, and the issue cannot be resolved within a reasonable timeframe.",
                    "If you cancel your subscription within the refund period outlined below."
                  ].map((item, index) => (
                    <li key={index} className="flex items-start space-x-3 text-gray-700">
                      <span className="w-2 h-2 mt-2 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex-shrink-0"></span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mt-12">
                <h2 className="text-4xl font-black mb-6" style={gradientTextStyle}>Refund Period</h2>
                <p className="text-gray-700">
                  Refund requests must be made within <strong className="text-purple-700">1</strong> days of the payment date. Requests made after this period will not be eligible for a refund.
                </p>
              </div>

              <div className="mt-12">
                <h2 className="text-4xl font-black mb-6" style={gradientTextStyle}>Non-Refundable Cases</h2>
                <p className="text-gray-700">Refunds will not be granted under the following conditions:</p>
                <ul className="space-y-3 mt-4">
                  {[
                    "If you change your mind after purchasing a subscription or service.",
                    "If you fail to use the service during the subscription period.",
                    "If the issue is caused by third-party software or tools not affiliated with our platform."
                  ].map((item, index) => (
                    <li key={index} className="flex items-start space-x-3 text-gray-700">
                      <span className="w-2 h-2 mt-2 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex-shrink-0"></span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mt-12">
                <h2 className="text-4xl font-black mb-6" style={gradientTextStyle}>Refund Process</h2>
                <p className="text-gray-700">To request a refund, please follow these steps:</p>
                <ol className="list-decimal pl-6 space-y-3 mt-4 text-gray-700">
                  <li>Contact our support team at <a href="mailto:shubhankardev8@gmail.com" className="text-purple-600 hover:text-purple-800">shubhankardev8@gmail.com</a>.</li>
                  <li>Provide your payment receipt, order ID, and a detailed explanation of the issue.</li>
                  <li>Our team will review your request and respond within 3-5 business days.</li>
                  <li>If your request is approved, the refund will be processed to your original payment method within 7-10 business days.</li>
                  <li>This has been generated by <a href="https://dodopayments.com" className="text-purple-600 hover:text-purple-800">dodopayments.com</a></li>
                </ol>
              </div>

              <div className="mt-12">
                <h2 className="text-4xl font-black mb-6" style={gradientTextStyle}>Contact Us</h2>
                <p className="text-gray-700">If you have any questions about this Refund Policy or require assistance, please reach out to us:</p>
                <div className="mt-4 bg-purple-50/50 rounded-xl p-6 border border-purple-100">
                  <p className="flex items-center space-x-2 text-gray-700">
                    <span className="w-2 h-2 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full"></span>
                    <span>Email: <a href="mailto:shubhankardev8@gmail.com" className="text-purple-600 hover:text-purple-800">shubhankardev8@gmail.com</a></span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RefundScreen;